import React from 'react';

interface IProps {
  link: string;
}

function FaqLink({ link }: IProps) {
  return (
    <span className='text-xs text-gray-500'>
      Se tiver dúvidas acesse nosso{' '}
      <a className='font-bold' href={link} target='_blank' rel='noopener noreferrer'>
        FAQ
      </a>
    </span>
  );
}

export default FaqLink;
